<template>
  <div class="legend">
    <div class="tab">
      <span @click="menuClick(false)" :class="!legend && 'active'"
        >状态监测</span
      >
      <span @click="menuClick(true)" :class="legend && 'active'">图例模式</span>
    </div>
    <div v-if="legend" class="menu">
      <div class="menu-select">
        <div>
          <el-radio-group v-model="activeRadio" @change="laneChange">
            <el-radio
              v-for="(item, index) in radioLaneList"
              :key="index"
              :label="item"
            ></el-radio>
          </el-radio-group>
        </div>
        <div class="menu-select--description">
          <span>正常</span>
          <span>故障</span>
          <span>未知</span>
        </div>
      </div>
    </div>
    <div v-if="legend">
      <div class="container" ref="legendRef"></div>
    </div>
    <div v-else class="data-group">
      <div class="data-group-item">
        <div>
          <img src="/static/img/allow.png" />
          <span>基础数据监测</span>
        </div>
        <div class="data-group-item__detail">
          <span>
            <img src="/static/img/status/dy.png" alt="" />
            <span>仪表电压</span>
            <span class="status"
              >{{ statusData["仪表电压"].value }}<span>V</span></span
            >
          </span>
          <span>
            <img src="/static/img/status/dy.png" alt="" />
            <span>工控机电压</span>
            <span class="status"
              >{{ statusData["工控机电压"].value }}<span>V</span></span
            >
          </span>
          <span>
            <img src="/static/img/status/dy.png" alt="" />
            <span>采集器电压</span>
            <span class="status"
              >{{ statusData["采集器电压"].value }}<span>V</span></span
            >
          </span>
          <span>
            <img src="/static/img/status/door.png" alt="" />
            <span>柜门状态</span>
            <span class="status">{{
              statusData["柜门状态"].value === "0" ? "关门" : statusData["柜门状态"].value === "1" ? "开门" : statusData["柜门状态"].value
            }}</span>
          </span>
          <span>
            <img src="/static/img/status/temp.png" alt="" />
            <span>温度</span>
            <span class="status"
              >{{ statusData["温度"].value }}<span>°C</span></span
            >
          </span>
          <span>
            <img src="/static/img/status/humidity.png" alt="" />
            <span>湿度</span>
            <span class="status"
              >{{ statusData["湿度"].value }}<span>%RH</span></span
            >
          </span>
          <span>
            <img :src="require('/public/static/img/status/humidity.png')" alt="" />
            <span>运维终端</span>
            <span class="status">{{ statusData['运维终端连接状态'] ? statusData['运维终端连接状态'].value : '-' }}</span>
          </span>
          <span>
            <img :src="require('/public/static/img/status/humidity.png')" alt="" />
            <span>小程序</span>
            <span class="status">{{ statusData['监测小程序连接状态'] ? statusData['监测小程序连接状态'].value : '-' }}</span>
          </span>
        </div>
      </div>
      <div class="data-group-item">
        <div>
          <img src="/static/img/allow.png" />
          <span>通信监测</span>
        </div>
        <div class="data-group-item__detail">
          <span>
            <img src="/static/img/status/site.png" alt="" />
            <span>站级软件</span>
            <span class="status">{{
              statusData["站级软件"] ? statusData["站级软件"].value : "-"
            }}</span>
          </span>
          <span>
            <img
              :src="require('/public/static/img/status/province.png')"
              alt=""
            />
            <span>省平台</span>
            <span class="status">{{
              statusData["省平台"] ? statusData["省平台"].value : "-"
            }}</span>
          </span>
          <span>
            <img :src="require('/public/static/img/status/city.png')" alt="" />
            <span>市平台</span>
            <span class="status">{{
              statusData["市平台"] ? statusData["市平台"].value : "-"
            }}</span>
          </span>
          <span>
            <img
              :src="require('/public/static/img/status/cityStore.png')"
              alt=""
            />
            <span>市平台存储</span>
            <span class="status">{{
              statusData["市平台存储"] ? statusData["市平台存储"].value : "-"
            }}</span>
          </span>

          <span>
            <img src="/static/img/status/board.png" alt="" />
            <span class="multiple">
              <el-popover
                popper-class="custom-popper"
                placement="bottom"
                :width="280"
                trigger="click"
              >
                <template #reference>
                  <span @click="multipleClick('情报板')">情报板</span>
                </template>
                <el-table
                  :data="multipleDialogData"
                  max-height="300"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                >
                  <el-table-column property="name" label="情报板" />
                  <el-table-column property="value" label="状态" />
                </el-table>
              </el-popover>
            </span>
            <span class="status">{{ boardStatusValue }}</span>
          </span>
          <span>
            <img src="/static/img/status/center.png" alt="" />
            <span>中心平台</span>
            <span class="status">{{ statusData["中心平台"].value }}</span>
          </span>
          <span>
            <img src="/static/img/status/meter.png" alt="" />
            <span class="multiple">
              <el-popover
                popper-class="custom-popper"
                placement="bottom"
                :width="280"
                trigger="click"
              >
                <template #reference>
                  <span @click="multipleClick('仪表')">仪表</span>
                </template>
                <el-table
                  :data="multipleDialogData"
                  max-height="300"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                >
                  <el-table-column property="name" label="仪表" />
                  <el-table-column property="version" label="版本号" />
                  <el-table-column property="value" label="状态" />
                </el-table>
              </el-popover>
            </span>
            <span class="status">{{ meterStatusValue }}</span>
          </span>
          <span>
            <img src="/static/img/status/collector.png" alt="" />
            <span class="multiple">
              <el-popover
                popper-class="custom-popper"
                placement="bottom"
                :width="280"
                trigger="click"
              >
                <template #reference>
                  <span @click="multipleClick('采集器')">采集器</span>
                </template>
                <el-table
                  :data="multipleDialogData"
                  max-height="300"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                >
                  <el-table-column property="name" label="采集器" />
                  <el-table-column property="version" label="版本号" />
                  <el-table-column property="value" label="状态" />
                </el-table>
              </el-popover>
            </span>
            <span class="status">{{ collectorStatusValue }}</span>
          </span>
          <span>
            <img src="/static/img/status/camera.png" alt="" />
            <span class="multiple">
              <el-popover
                popper-class="custom-popper"
                placement="bottom"
                :width="300"
                trigger="click"
              >
                <template #reference>
                  <span @click="multipleClick('相机')">相机</span>
                </template>
                <el-table
                  :data="multipleDialogData"
                  max-height="300"
                  :header-cell-style="tableHeaderCell"
                  :cell-style="tableCell"
                >
                  <el-table-column
                    property="laneNum"
                    width="100"
                    label="车道"
                  />
                  <el-table-column property="name" width="100" label="相机" />
                  <el-table-column property="value" label="状态" />
                </el-table>
              </el-popover>
            </span>
            <span class="status">{{ cameraStatusValue }}</span>
          </span>
          <span>
            <img
              :src="require('/public/static/img/status/center.png')"
              alt=""
            />
            <span>NVR</span>
            <span class="status">{{
              statusData["NVR"] ? statusData["NVR"].value : "-"
            }}</span>
          </span>
          <span>
            <img
              :src="require('/public/static/img/status/center.png')"
              alt=""
            />
            <span>PDU通讯</span>
            <span class="status">{{
              statusData["PDU通讯"] ? statusData["PDU通讯"].value : "-"
            }}</span>
          </span>
        </div>
      </div>
      <div class="data-group-item">
        <div>
          <img src="/static/img/allow.png" />
          <span>称台监测</span>
        </div>
        <div class="data-group-item__detail">
          <span v-for="item in multipleData['称台']" :key="item.id">
            <img src="/static/img/status/weigh.png" alt="" />
            <span>{{ item.name }}</span>
            <span class="status">{{ item.value }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/";
import G6 from "./g6";
const yValue = -20;
const statusList = ["normal", "failed", "unknown"];
const statusMatch = value => {
  if (value === "正常") {
    return statusList[0];
  } else if (value === "故障") {
    return statusList[1];
  } else {
    return statusList[2];
  }
};
export const statusColorDict = new Proxy(
  {
    [statusList[0]]: "#155f68",
    [statusList[1]]: "red",
    [statusList[2]]: "gray"
  },
  {
    get(target, key) {
      return key in target ? target[key] : target[statusList[2]];
    }
  }
);

const imageWithStatusDesc = (prefix, statusDesc) => {
  return require(`/public/static/img/model/${prefix}_${statusDesc}.png`);
};
const cameraType = "相机";
const collectorType = "采集器";
const weighType = "称台";
const meterType = "仪表";
const boardType = "情报板";
const NVRType = "NVR";
const cameraDict = {
  左侧相机: "左侧",
  右侧相机: "右侧",
  车头相机: "车头",
  车尾相机: "车尾",
  其他相机: "其他"
};

const getTop = laneClassify => {
  let connectEdges = laneClassify ? laneClassify.connectEdges : [];
  let meter =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "仪表");
  let site =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "站级软件");
  let center =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "中心平台");
  let network =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "四级联网平台");
  let queue =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "中心平台消息队列");
  let province =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "省平台");
  let city =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "市平台");
  let cityStore =
    laneClassify &&
    laneClassify.otherDeviceList.find(e => e.deviceType === "市平台存储");
  let meterList = [];
  if (meter) {
    meterList.push({
      name: "仪表",
      statusDesc: meter && meter.statusDesc,
      image: imageWithStatusDesc("meter", meter.statusDesc)
    });
  }
  const platformList = [];
  if (site) {
    platformList.push({
      name: "站级软件",
      statusDesc: site.statusDesc,
      image: imageWithStatusDesc("site", site.statusDesc)
    });
  }
  if (center) {
    platformList.push({
      name: "中心平台",
      statusDesc: center.statusDesc,
      image: imageWithStatusDesc("center", center.statusDesc)
    });
  }
  if (network) {
    platformList.push({
      name: "四级联网平台",
      statusDesc: network.statusDesc,
      image: imageWithStatusDesc("platform", network.statusDesc)
    });
  }
  if (queue) {
    platformList.push({
      name: "消息队列",
      statusDesc: queue.statusDesc,
      image: imageWithStatusDesc("queue", queue.statusDesc)
    });
  }
  if (province) {
    platformList.push({
      name: "省平台",
      statusDesc: province.statusDesc,
      image: imageWithStatusDesc("province", province.statusDesc)
    });
  }
  if (city) {
    platformList.push({
      name: "市平台",
      statusDesc: city.statusDesc,
      image: imageWithStatusDesc("city", city.statusDesc)
    });
  }
  if (cityStore) {
    platformList.push({
      name: "市平台存储",
      statusDesc: cityStore.statusDesc,
      image: imageWithStatusDesc("cityStore", cityStore.statusDesc)
    });
  }
  const topList = [...meterList, ...platformList];
  let topNode = topList.map((item, index) => ({
    id: item.name,
    x: 100 + index * 200,
    y: 100 + yValue,
    statusDesc: item.statusDesc,
    labelName: item.name,
    type: "dom-rect",
    size: [100, 53],
    image: item.image
  }));
  /**
   * 中心平台消息队列 归属于 中心平台
   * 省平台 和 市平台 和站级软件连线
   * 市平台存储 和 市平台连线
   */
  const siteNode = topNode.find(e => e.id === "站级软件");
  const centerNode = topNode.find(e => e.id === "中心平台");
  const queueNode = topNode.find(e => e.id === "消息队列");
  const provinceNode = topNode.find(e => e.id === "省平台");
  const cityNode = topNode.find(e => e.id === "市平台");
  const cityStoreNode = topNode.find(e => e.id === "市平台存储");
  const y = 80;
  topNode.forEach(e => {
    if (queueNode && e.id === queueNode.id) {
      queueNode.x = centerNode.x + 120;
      queueNode.y = centerNode.y - y;
    }
    if (provinceNode && cityNode) {
      provinceNode.x = siteNode.x - 55;
      provinceNode.y = siteNode.y - y;
      cityNode.x = siteNode.x + 55;
      cityNode.y = siteNode.y - y;
    } else if (provinceNode) {
      provinceNode.x = siteNode.x;
      provinceNode.y = siteNode.y - y;
    } else if (cityNode) {
      cityNode.x = siteNode.x;
      cityNode.y = siteNode.y - y;
    }
    if (cityStoreNode && e.id === cityStoreNode.id) {
      if (cityNode) {
        cityStoreNode.x = cityNode.x + 100;
        cityStoreNode.y = cityNode.y;
      } else {
        cityStoreNode.x = siteNode.x;
        cityStoreNode.y = siteNode.y - y;
      }
    }
  });
  const topEdge = [];
  const edgeList = topList.filter(
    e => !["省平台", "市平台", "消息队列", "市平台存储"].includes(e.name)
  );
  if (edgeList.length > 1) {
    for (let i = 0; i < edgeList.length - 1; i++) {
      let source = edgeList[i];
      let sourceName = source ? source.name : "";
      let targetName = edgeList[i + 1] ? edgeList[i + 1].name : "";
      if (sourceName && targetName) {
        let id = `${sourceName}_${targetName}`;
        let edge = connectEdges.find(e => e.statusName === id) || {};
        topEdge.push({
          id: id,
          source: sourceName,
          target: targetName,
          type: "line",
          color: statusColorDict[edge.statusDesc]
        });
        console.log("topEdge", topEdge);
      }
    }
  }
  const siteName = "站级软件";
  if (provinceNode) {
    let id = `${siteName}_${provinceNode.id}`;
    let edge = connectEdges.find(e => e.statusName === id);
    if (edge) {
      topEdge.push({
        id: id,
        source: "站级软件",
        target: provinceNode.id,
        type: "line",
        color: statusColorDict[edge.statusDesc]
      });
    }
  }
  if (cityNode) {
    let id = `${siteName}_${cityNode.id}`;
    let edge = connectEdges.find(e => e.statusName === id);
    if (edge) {
      topEdge.push({
        id: id,
        source: "站级软件",
        target: cityNode.id,
        type: "line",
        color: statusColorDict[edge.statusDesc],
        controlPoints: [{ x: siteNode.x + 50, y: siteNode.y + 25 }]
      });
    }
  }
  if (queueNode) {
    let id = `中心平台_${queueNode.id}`;
    let edge = connectEdges.find(e => e.statusName === id) || {};
    topEdge.push({
      id: id,
      source: "中心平台",
      target: queueNode.id,
      type: "line",
      color: statusColorDict[edge.statusDesc],
      // controlPoints: [
      //   { x: centerNode.x + 50, y: centerNode.y - 25 },
      //   { x: centerNode.x + 150, y: centerNode.y },
      // ],
      style: {
        endArrow: false,
        startArrow: false
      }
    });
  }
  if (cityStoreNode) {
    let id = `市平台_${cityStoreNode.id}`;
    let edge = connectEdges.find(e => e.statusName === id);
    if (edge) {
      topEdge.push({
        id: id,
        source: "市平台",
        target: cityStoreNode.id,
        type: "line",
        color: statusColorDict[edge.statusDesc]
      });
    }
  }

  return { topNode, topEdge };
};
const getLane = laneList => {
  // 车道连接站级软件的边
  const laneToSiteEdge = laneData => {
    let list = [];
    if (!laneData || laneData.length === 0) {
      return list;
    } else {
      return laneData.map((item, index) => ({
        id: `${item.laneName}_站级软件`,
        source: item.laneName,
        target: "站级软件",
        type: "polyline",
        color: "#1d6b74",
        controlPoints: [
          { x: 108 + index * 200, y: 180 + yValue },
          { x: 350, y: 180 + yValue }
        ]
      }));
    }
  };

  let laneNode = laneList.map((item, index) => ({
    id: item.laneName,
    x: 10 + index * 200,
    y: 200 + yValue,
    type: "dom-lane",
    size: [195, 80],
    lane: {
      name: item.laneName,
      camera: item.deviceList
        .filter(e => e.deviceType === "相机")
        .map(e => ({
          labelName: e.name,
          statusDesc: e.statusDesc,
          image: imageWithStatusDesc("camera", e.statusDesc)
        }))
    }
  }));
  let laneEdge = laneToSiteEdge(laneList);
  return { laneNode, laneEdge };
};
const getNvr = nvr => {
  if (nvr) {
    let nvrNode = {
      id: "NVR录像机",
      x: 820,
      y: 380 + yValue,
      labelName: "NVR录像机",
      statusDesc: nvr.statusDesc,
      type: "dom-rect",
      size: [100, 53],
      image: imageWithStatusDesc("NVR", nvr.statusDesc)
    };
    let nvrEdge = {
      id: "NVR录像机-站级软件",
      source: "NVR录像机",
      target: "站级软件",
      type: "polyline",
      color: "#1d6b74",
      controlPoints: [
        { x: 934, y: 406 + yValue },
        { x: 934, y: 180 + yValue },
        { x: 350, y: 180 + yValue }
      ]
    };
    return { nvrNode: [nvrNode], nvrEdge: [nvrEdge] };
  } else {
    return { nvrNode: [], nvrEdge: [] };
  }
};
const getCollector = collectorData => {
  let node = collectorData.map((item, index) => ({
    id: item.name,
    x: 50 + index * 200,
    y: 350 + yValue,
    labelName: item.name,
    type: "dom-rect",
    size: [100, 53],
    statusDesc: item.statusDesc,
    image: imageWithStatusDesc("collector", item.statusDesc)
  }));
  let edge = collectorData.map((item, index) => ({
    id: `${item.name}_仪表`,
    source: item.name,
    target: "仪表",
    type: "polyline",
    color: "#1d6b74",
    controlPoints: [
      { x: 100 + index * 200, y: 320 + yValue },
      { x: 0, y: 320 + yValue },
      { x: 0, y: 128 + yValue }
    ]
  }));
  return { collectorNode: node, collectorEdge: edge };
};
const getBoard = boardData => {
  let node = boardData.map((e, index) => ({
    id: e.name,
    x: 820,
    y: index * 70 + 228 + yValue,
    labelName: e.name,
    type: "dom-rect",
    size: [100, 53],
    statusDesc: e.statusDesc,
    image: imageWithStatusDesc("meter", e.statusDesc)
  }));
  let edge = boardData.map(e => ({
    id: `${e.name}_站级软件`,
    source: e.name,
    target: "站级软件",
    type: "polyline",
    color: "#1d6b74",
    controlPoints: [
      { x: 870, y: 180 + yValue },
      { x: 350, y: 180 + yValue }
    ]
  }));
  return { boardNode: node, boardEdge: edge };
};
// 通过地图扎点获取的数据组装g6所需数据
const g6Data = laneClassify => {
  let laneDevice = laneClassify.terminalLaneDeviceList || [];
  let laneList = laneDevice.map(e => {
    e.laneName = `车道${e.laneNum}`;
    return e;
  });
  let { laneNode, laneEdge } = getLane(laneList);
  let { nvrNode, nvrEdge } = getNvr(
    laneClassify.otherDeviceList.find(e => e.deviceType === "NVR")
  );
  let collectorData = laneDevice.map(e => {
    let c = e.deviceList.find(e => e.deviceType === collectorType);
    return c;
  });
  let { collectorNode, collectorEdge } = getCollector(collectorData);
  let boardData =
    laneClassify.otherDeviceList.filter(e => e.deviceType === "情报板") || [];
  let { boardNode, boardEdge } = getBoard(boardData);
  let { topNode, topEdge } = getTop(laneClassify);
  const g = {
    nodes: [
      ...topNode,
      ...laneNode,
      ...collectorNode,
      ...nvrNode,
      ...boardNode
    ], // 点集
    edges: [...topEdge, ...laneEdge, ...collectorEdge, ...nvrEdge, ...boardEdge] // 边集
  };
  return g;
};
let graph = null; // g6 instance

// 最大4个车道一组将 sourceData拆分为独立的数据(dialog最大展示4个车道, 其它数据通过切换车道展示)
const laneNum = 4; // 最大显示4个车道数据

export default {
  name: "",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      sourceData: null,
      legend: false, // 默认状态监测
      activeRadio: "",
      tableCell: {
        backgroundColor: "#00756f",
        color: "#fff",
        border: "none"
      },
      tableHeaderCell: {
        backgroundColor: "#00756f",
        color: "#b2d1f9",
        border: "none"
      },
      statusData: {},
      multipleData: {
        情报板: [],
        相机: [],
        仪表: [],
        采集器: [],
        称台: []
      },
      multipleShow: false,
      multipleDialogData: []
    };
  },

  computed: {
    boardStatusValue() {
      let item = this.multipleData["情报板"].find(e => e.value !== "正常");
      return item ? item.value : "正常";
    },
    meterStatusValue() {
      let item = this.multipleData["仪表"].find(e => e.value !== "正常");
      return item ? item.value : "正常";
    },
    collectorStatusValue() {
      let item = this.multipleData["采集器"].find(e => e.value !== "正常");
      return item ? item.value : "正常";
    },
    cameraStatusValue() {
      let item = this.multipleData["相机"].find(e => e.value !== "正常");
      return item ? item.value : "正常";
    },
    laneClassifyData: function() {
      let num =
        this.sourceData.terminalDevice.terminalLaneDeviceList.length || 0;
      if (num < laneNum) {
        return [this.sourceData.terminalDevice];
      } else {
        let list = [];
        let {
          terminalLaneDeviceList,
          ...other
        } = this.sourceData.terminalDevice;
        for (let i = 0; i < Math.ceil(num / laneNum); i++) {
          let start = i * laneNum;
          let end = laneNum * (i + 1);
          list.push({
            ...other,
            terminalLaneDeviceList: terminalLaneDeviceList.slice(start, end)
          });
        }
        return list;
      }
    },
    radioLaneList: function() {
      return this.laneClassifyData.map((e, index) => {
        let value = "";
        if (index === 0) {
          value = `车道1-${laneNum}`;
          this.activeRadio = value;
        } else {
          value = `车道${index * laneNum + 1}-${index * laneNum + laneNum}`;
        }
        return value;
      });
    }
  },

  methods: {
    renderLegend(laneClassify, firstRender = true) {
      let data = g6Data(laneClassify);
      try {
        if (firstRender) {
          graph = new G6.Graph({
            container: this.$refs.legendRef,
            width: 939,
            height: 500,
            renderer: "svg",
            defaultNode: {
              stateIcon: {
                show: true
              },
              logoIcon: {
                show: false
              },
              preRect: {
                show: false
              }
            },
            defaultEdge: {
              style: {
                endArrow: true,
                startArrow: false,
                lineWidth: 1.4
              }
            }
          });
          graph.data(data); // 读取 Step 2 中的数据源到图上
          graph.render();
        } else {
          graph.changeData(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    addFalutStatus() {
      let statusDomList = document.querySelectorAll(".status");
      statusDomList.forEach(span => {
        if (span.innerText.includes("故障")) {
          span.classList.add("fault");
        } else {
          span.classList.remove("fault");
        }
      });
    },
    multipleClick(name) {
      this.multipleDialogData = [];
      let list = this.multipleData[name];
      if (list.length > 0) {
        this.multipleShow = true;
        this.multipleDialogData = list;
      }
    },

    monitorCallback(data /**组件参数data变动后执行的回调 */) {
      let multipleKeys = Object.keys(this.multipleData);
      this.sourceData = data;
      multipleKeys.forEach(key => {
        this.multipleData[key] = [];
      });
      let d = [
        ...(data.terminalDeviceStatusList || []),
        ...(data.terminalMonitorStatusList || [])
      ].map(e => {
        return {
          name: e.deviceName || e.statusName,
          value: e.deviceStatus || e.statusValue,
          ...e
        };
      });

      d.forEach(item => {
        // 设备名称与其对应的状态值
        this.statusData[item.name] = item;
        // 多个相同类型的设备分组存储
        let key = multipleKeys.find(
          name =>
            (item.name.includes(name) && item.laneNum != undefined) ||
            (item.deviceName && item.deviceName.includes(name))
        );
        if (key) {
          this.multipleData[key].push(item);
        }
      });
      this.$nextTick(() => {
        this.addFalutStatus();
      });
    },

    laneChange(name) {
      let index = this.radioLaneList.indexOf(name);
      if (index !== -1) {
        let d = this.laneClassifyData[index];
        if (d) {
          this.$nextTick(() => {
            this.renderLegend(d, false);
          });
        }
      }
    },
    menuClick(value) {
      if (this.legend === value) {
        return;
      }
      this.legend = value;
      if (value === true) {
        this.$nextTick(() => {
          // 切换菜单默认展示1-4车道数据
          if (this.laneClassifyData.length > 0) {
            let index = this.radioLaneList.indexOf(this.activeRadio);
            this.renderLegend(this.laneClassifyData[index]);
          }
        });
      } else {
        this.$nextTick(() => {
          this.addFalutStatus();
        });
      }
    }
  },
  watch: {
    data: {
      handler: function(data) {
        if (data) {
          data.terminalDeviceStatusList.forEach(e => {
            if (e.deviceName.includes("nvr")) {
              e.deviceStatus = "正常";
            }
            if (e.deviceName === "nvr") {
              e.deviceStatus = "故障";
            }
          });
          let d = deepClone(data);
          let laneList =
            d.terminalDevice.terminalLaneDeviceList.sort(
              (a, b) => a.laneNum - b.laneNum
            ) || [];
          let deviceStatusList = d.terminalDeviceStatusList || [];
          if (!d.terminalDevice) {
            d.terminalDevice = {};
          }
          d.terminalDevice["terminalLaneDeviceList"] = laneList;
          let otherDeviceList = []; // 非车道关联设备
          deviceStatusList.forEach(device => {
            let laneNum = device.laneNum;
            // 设备是否正常
            device.statusDesc = statusMatch(device.deviceStatus);
            let lane = laneList.find(e => e.laneNum == laneNum);
            if (lane) {
              // 将所有设备分配到对应的车道中, 重新定义名称属性以及为相机添加 type 方面使用的时候提取
              let keys = Object.keys(cameraDict);
              if (keys.includes(device.deviceName)) {
                device.name = cameraDict[device.deviceName];
                device.deviceType = cameraType;
              } else {
                device.name = device.deviceName;
              }
              if (device.name.includes(collectorType)) {
                device.deviceType = collectorType;
              }
              if (device.name.includes(weighType)) {
                device.deviceType = weighType;
              }
              if (lane.deviceList) {
                lane.deviceList.push(device);
              } else {
                lane.deviceList = [device];
              }
            } else {
              device.name = device.deviceName;
              if (device.name.includes(meterType)) {
                device.deviceType = meterType;
              }
              if (device.name.includes(boardType)) {
                device.deviceType = boardType;
              }
              if (device.name.includes(NVRType)) {
                device.deviceType = NVRType;
              }
              otherDeviceList.push(device);
            }
          });
          let platform = d.terminalMonitorStatusList
            .filter(e =>
              [
                "站级软件",
                "中心平台",
                "四级联网平台",
                "中心平台消息队列",
                "省平台",
                "市平台",
                "市平台存储"
              ].includes(e.statusName)
            )
            .map(e => {
              e.statusDesc = statusMatch(e.statusValue);
              e.deviceType = e.statusName;
              return e;
            });
          d.terminalDevice.otherDeviceList = [...otherDeviceList, ...platform];
          let connectEdges = d.terminalMonitorStatusList
            .filter(e =>
              [
                "仪表_站级软件",
                "站级软件_中心平台",
                "中心平台_四级联网平台",
                "工控机_省平台",
                "工控机_市平台"
              ].includes(e.statusName)
            )
            .map(e => {
              if (e.statusName === "工控机_省平台") {
                e.statusName = "站级软件_省平台";
                return e;
              }
              if (e.statusName === "工控机_市平台") {
                e.statusName = "站级软件_市平台";
                return e;
              }
              return e;
            })
            .map(e => {
              console.log("eeee", e);
              e.statusDesc = statusMatch(e.statusValue);
              return e;
            });
          d.terminalDevice.connectEdges = connectEdges;
          this.monitorCallback(d);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style scoped lang="less">
.legend {
  user-select: none;
  margin: 0 20px;
  .tab {
    width: 221px;
    height: 30px;
    line-height: 30px;
    margin: 0 auto;
    margin-top: 24px;
    user-select: none;
    font-size: 14px;
    color: #fff;
    outline: 1px #1d6a74 solid;
    box-sizing: border-box;
    cursor: pointer;
    > span {
      text-align: center;
      box-sizing: border-box;
      width: 50%;
      line-height: 30px;
      display: inline-block;
      &:not(:last-child) {
        border-right: 1px #1d6a74 solid;
      }
    }
    .active {
      background-color: #1d6a74;
    }
  }
  ::v-deep .menu {
    margin: 10px 0;
    .menu-select {
      display: flex;
      user-select: none;
      justify-content: space-between;
      width: 70%;
      margin: 0 auto;
      color: #fff;
      .el-radio {
        color: #fff;
      }
      .is-checked {
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #1f7882;
          background: #1f7882;
        }
        .el-radio__label {
          color: #fff;
        }
      }

      .menu-select--description {
        span {
          display: inline-block;
          font-size: 14px;
          &:nth-child(2) {
            margin: 0 20px;
          }
          &:nth-child(1)::before {
            background-color: #155f68;
          }
          &:nth-child(2)::before {
            background-color: #ff0000;
          }
          &:nth-child(3)::before {
            background-color: gray;
          }
          &::before {
            content: "";
            vertical-align: middle;
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
        }
      }
    }
  }
  .container {
    width: 939px;
    height: 500px;
  }
  ::v-deep .data-group {
    margin-top: 20px;
    .data-group-item {
      color: #fff;
      > div {
        &:nth-child(1) {
          font-size: 16px;
          margin: 14px 0;
          img {
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        &:nth-child(2) {
          background-color: rgba(29, 106, 116, 0.38);
          border: solid 1px rgb(29, 106, 116);
          padding: 10px;
          display: grid;
          grid-template-columns: repeat(4, 225px);
          grid-template-rows: 30px;
        }
      }
      .data-group-item__detail {
        .fault {
          color: #e10e0e !important;
        }
        > span {
          color: #fff;
          font-size: 15px;
          line-height: 1;
          display: inline-block;
          line-height: 30px;
          .el-tooltip__trigger {
            color: #42cafc;
            border-bottom: 1px #42cafc solid;
            cursor: pointer;
          }
          img {
            vertical-align: middle;
            width: 20px;
          }
          > span {
            margin: 0 16px;
            &:nth-child(2) {
              display: inline-block;
              min-width: 90px;
            }
            &:last-child {
              font-size: 18px;
              color: #0ee312;
              margin: 0;
              > span {
                color: #fff;
                margin-left: 1px;
              }
            }
          }
        }
      }
    }
  }
}
</style>